module.exports = __webpack_public_path__ + "static/modern-software-delivery-1b19badf8da51b4739a5bb43fd159230.jpg";